import PropTypes from 'prop-types'

import { TranslationContextProvider } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'
import { isSet } from '../../../../helpers'
import { useDiscover } from '../../hooks/useDiscover'
import { EVALUATION_CONTEXT } from '../../utils'
import { DISCOVER_TALENT_LOCK } from '../../utils/talent-storage-lock'
import LockedTalentSection from '../LockedTalentSection'
import TalentProfileSection from '../TalentProfileSection'

export default function ConditionalTalentProfileSection({
  talent,
  career,
  talentProfile,
  className = '',
  isLoading,
  resultLock
}) {
  const { selectedResult } = useDiscover()

  const shouldRenderProfile =
    selectedResult === EVALUATION_CONTEXT.TALENTPROFILE && isSet(talent)

  if (!shouldRenderProfile) return null

  // Gesperrt oder noch nicht gezählt, dann weder Talentprofil noch PDF
  if (
    resultLock === DISCOVER_TALENT_LOCK.LOCKED ||
    resultLock === DISCOVER_TALENT_LOCK.PENDING
  ) {
    return (
      <LockedTalentSection
        className={className}
        pending={resultLock === DISCOVER_TALENT_LOCK.PENDING}
      />
    )
  }

  const translationData = talentProfile ?? {}

  return (
    <TranslationContextProvider data={translationData}>
      <TalentProfileSection
        talent={talent}
        career={career}
        talentProfile={talentProfile}
        className={className}
        isLoading={isLoading}
      />
    </TranslationContextProvider>
  )
}

ConditionalTalentProfileSection.propTypes = {
  talent: PropTypes.shape({ id: PropTypes.string }),
  career: PropTypes.object,
  talentProfile: PropTypes.object,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  resultLock: PropTypes.oneOf(Object.values(DISCOVER_TALENT_LOCK))
}
